<template>
  <div class="disclaimer">
    <p v-html="data.body"></p>
  </div>
</template>

<script>
export default {
  name: 'disclaimer',
  props: {
    'data': {
      type: Object,
      default: {}
    }
  }
}

</script>



// WEBPACK FOOTER //
// BlockDisclaimer.vue?28bf5cb2